export var DataDrillView;
(function (DataDrillView) {
    DataDrillView[DataDrillView["Grid"] = 2] = "Grid";
    DataDrillView[DataDrillView["Blurb"] = 32] = "Blurb";
    DataDrillView[DataDrillView["Text"] = 64] = "Text";
})(DataDrillView || (DataDrillView = {}));
;
